import type { QueryClient } from '@tanstack/react-query';

import { fileKeys } from './queryKeys';

/**
 * Forget every cached listing of this workspace's files.
 *
 * For a surface outside this feature that has just written into the
 * workspace's storage — the Library installs an agent into `.agents/<key>`,
 * updates one, or takes one back out — and cannot know which listings that
 * touched. Exported rather than the key factory so the knowledge of how a
 * listing is keyed stays in the feature that owns it.
 *
 * Coarse on purpose: a write from elsewhere changes the folder, its parent's
 * listing, and the workspace's change log, and guessing which of those a
 * caller touched is how a page ends up showing a file that is not there. A
 * workspace holds tens of folders, not thousands.
 *
 * Without this, installing an agent and then opening Files showed the listing
 * from before the install for as long as it stayed fresh, and removing one
 * left the folder on screen until a reload.
 */
export function invalidateWorkspaceFiles(
  queryClient: QueryClient,
  workspaceId: string,
): Promise<void> {
  return queryClient.invalidateQueries({
    queryKey: fileKeys.all(workspaceId),
  });
}
